var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @format */
import React from 'react';
import Base from 'react-icon-base';
import classnames from 'classnames';
const IconBase = props => {
    const { className, style } = props, other = __rest(props, ["className", "style"]);
    const classNames = classnames({
        anticon: true,
        [className || '']: className || '',
    });
    return (<span role="img" className={classNames}>
      <Base {...other} style={Object.assign({ verticalAlign: 'baseline' }, style)}/>
    </span>);
};
export default IconBase;
